// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".classify .demo-ruleForm[data-v-5af22e2f]{width:400px;display:inline-block;margin:0 10px 0 0}.classify .el-table[data-v-5af22e2f]{margin:0 0 0 20px}.classify[data-v-5af22e2f] td{padding:0;height:50px;line-height:50px}", ""]);
// Exports
module.exports = exports;
